import React, { useState } from 'react';
import { externalLinkIcon } from "assets/icons";

const SourceInfo = ({ data }: any) => {
    const [showMore, setShowMore] = useState(false)

    const handleShow = () => {
        setShowMore(!showMore)
    }


    return (
        <div className="featured-container">
            <div className="learn-more-text-container">
                {/* <p>Learn More :</p> */}
            </div>
            <div className="sourceInfo-container">
                <h6>References taken from:</h6>
                {data.map((rData: any, indx: any) => (
                    <div className="sourceInfo-items-container" key={indx}>
                        <a className="sourceInfo-txt" href={rData.link} target="_blank">
                            <span className='sourceInfo-name'>{rData.name}</span>
                            <img className="healthcare-externalink-icon" src={externalLinkIcon} alt="external-link" />
                        </a>
                    </div>
                ))}
                {/* {data.length > 3 && <button className="healthcare-expand-button" onClick={()=>{handleShow()}}>{showMore ? '— Less' : '+ Mmore'}</button>} */}
                {/* {data.length > 3 && <button className="sourceInfo-expand-button" onClick={() => { handleShow() }}>{showMore ? `— Less` : `+ ${data.length - 3} more`}</button>} */}
            </div>

        </div>
    );
};

export default SourceInfo;